import React from "react";

export const TableUpdateContext = React.createContext(null)